import DocumentationAlias from './documentationalias'

export default DocumentationAlias